import { generateUtilityClasses } from '@mui/material'

export type DropdownSize = 'small' | 'medium'

export const MenuItemClasses = generateUtilityClasses<DropdownSize>('MenuItem', ['small', 'medium'])
